import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LoanOfficer.css";
import htmlParser from "html-react-parser";


export default function Banner({
  featurenData,
  loanOfficer,
  Contactdata,
  loInformation,
  loanRealtor,
}) {


  return (
    <>
      {/* Render inside dynamiclorealtorsection div */}
      <div className="dynamiclorealtorsection">
        <Container>
          <Row className="justify-content-center">
            <Col sm={12} md={12} lg={10} xl={10}>
              {loanRealtor ? (
                <Row>
                  <Col sm={12} md={12} lg={6} xl={6}>
                    <div className="lodetails">
                      <img
                        src={htmlParser(loanOfficer.Image)}
                        className="img-fluid loimgdent"
                        alt="LoanOfficer"
                      ></img>
                      <div className="lodetaidivco">
                        <p className="salvadornametitle">
                          {htmlParser(loanOfficer.Name)}
                        </p>
                        <div className="loseconddetail1">
                          <p>{htmlParser(loanOfficer.NMLSID)}</p>
                          <p>{htmlParser(loanOfficer.Designation)}</p>
                          <p>
                            <a href={"tel:" + loanOfficer.formatPhone}>
                              D: {loanOfficer.Phone}
                            </a>
                          </p>
                          <p>
                            <a
                              href={"mailto:" + loanOfficer.EmailId}
                              title={"Email me at " + loanOfficer.EmailId}
                              aria-label={"Email me at " + loanOfficer.EmailId}
                            >
                              {loanOfficer.EmailId}
                            </a>
                          </p>
                          <p>{htmlParser(loanOfficer.RetailEmailId)}</p>
                          <p>{htmlParser(loanOfficer.branchAddress)}</p>
                         
                        </div>
                      </div>
                    </div>
                  </Col>
                 
                  <Col sm={12} md={12} lg={6} xl={6}>
                  
                    <div className="lodetails2">
                      <div className="lodetaidivco">
                        <p className="salvadornametitleco">
                          {htmlParser(loanRealtor.Name)}
                        </p>
                        <div className="loseconddetail">
                          <p>{htmlParser(loanRealtor.NMLSID)}</p>
                          <p>{htmlParser(loanRealtor.Designation)}</p>
                          <p>
                            <a href={"tel:" + loanRealtor.formatPhone}>
                              M: {loanRealtor.Phone}
                            </a>
                          </p>
                          <p>
                            <a
                              href={"mailto:" + loanRealtor.EmailId}
                              title={"Email me at " + loanRealtor.EmailId}
                              aria-label={"Email me at " + loanRealtor.EmailId}
                            >
                              {loanRealtor.EmailId}
                            </a>
                          </p>
                          <p>{htmlParser(loanRealtor.RetailEmailId)}</p>
                          <p>{htmlParser(loanRealtor.branchAddress)}</p>
                        </div>
                      </div>
                      <img
                        src={htmlParser(loanRealtor.Image)}
                        className="img-fluid loimgdent"
                        alt=""
                      ></img>
                    </div>
                    
                  </Col>
                </Row>
              ) : (
                // If Realtor data is not available, render Loan Officer section in the center
                <Row>
                  <Col sm={12} md={12} lg={12} xl={12} className="">
                    <div className="lodetailsextra">
                      <img
                        src={htmlParser(loanOfficer.Image)}
                        className="img-fluid loimgdentoptional"
                        alt="LoanOfficer"
                      ></img>
                      <div className="lodetaidiv">
                        <p className="salvadorname">
                          {htmlParser(loanOfficer.Name)}
                        </p>
                        <div className="loseconddetail1">
                          <p>{htmlParser(loanOfficer.NMLSID)}</p>
                          <p>{htmlParser(loanOfficer.Designation)}</p>
                          <p>
                            <a href={"tel:" + loanOfficer.formatPhone}>
                              D: {loanOfficer.Phone}
                            </a>
                          </p>
                          <p>
                            <a
                              href={"mailto:" + loanOfficer.EmailId}
                              title={"Email me at " + loanOfficer.EmailId}
                              aria-label={"Email me at " + loanOfficer.EmailId}
                            >
                              {loanOfficer.EmailId}
                            </a>
                          </p>
                          <p>{htmlParser(loanOfficer.RetailEmailId)}</p>
                          <p>{htmlParser(loanOfficer.branchAddress)}</p>
                          {loanOfficer.calenderlink && (
                            <p className="calenderlinkoflnk">
                              {htmlParser(loanOfficer.calenderlink)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
